import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { routerTransition } from '../../shared/animations/index';

@Component({
    selector: 'app-rating-intro',
    templateUrl: './intro.component.html',
    styleUrls: ['./intro.component.scss'],
    host: { '[@routerTransition]': '' },
    animations: [routerTransition],
    standalone: false
})
export class RatingIntroComponent implements OnInit {
  courseProgress: number = 0;
  video: boolean = false;
  audio: boolean = false;
  section: string = 'video'

  constructor(private router: Router, private route: ActivatedRoute) {
    this.courseProgress = 0

    this.route.url.subscribe( (url) => {
      this.video = url[2].path == 'video'
      this.audio = url[2].path == 'audio'
    })

  }

  ngOnInit() {

    if( this.audio ){
      this.courseProgress = 30
    }
    if( this.video ){
      this.courseProgress = 50
    }
   }

  onStart() {

    if( this.video ){
      this.router.navigate(['/rating/video'])
      return
    }

    if( this.audio ){
      this.router.navigate(['/rating/audio'])
      return
    }
  }
}
